import "./footer_block.pcss";
